import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("moodly_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/* Robust error formatter — takes the full axios error and surfaces the most
   useful message. Differentiates network errors (no response) from server
   errors (with response body) so users see real reasons instead of a vague
   "Something went wrong". */
export function formatApiError(err) {
  if (!err) return "Unknown error.";
  // Server responded with an error
  if (err.response) {
    const { status, data } = err.response;
    if (data?.detail != null) return formatApiErrorDetail(data.detail);
    if (typeof data === "string" && data.length < 240) return data;
    if (status === 401) return "Wrong email or password.";
    if (status === 403) return "Not allowed.";
    if (status === 404) return "Not found.";
    if (status === 409) return "Already exists.";
    if (status === 422) return "Please check the form fields.";
    if (status >= 500) return `Server error (${status}). Please try again in a moment.`;
    return `Request failed (${status}).`;
  }
  // Network error / CORS / timeout
  if (err.request) {
    return "Could not reach the server. Check your connection and try again.";
  }
  return err.message || "Unknown error.";
}

export function resolveImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}
